import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-28 px-6 bg-brand-white text-center" data-id="element-166">
      <div className="max-w-3xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-sm uppercase mb-6" data-id="element-169">
            LA SOLUCIÓN
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-purple mb-8 leading-tight" data-id="element-170">
          El Megapack Esteticista Profesional
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl font-sans text-gray-800 leading-relaxed mb-12" data-id="element-171">
          Es el sistema completo que reúne todo lo que necesitás para
          profesionalizar tu consultorio: protocolos, precios, contratos,
          marketing, gestión de clientes, cosmética y más. No son teorías — son
          herramientas listas para usar desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-172">
          <a href="https://gana-con-conocimiento.myshopify.com/cart/52148248248603:1" className="inline-block px-10 py-5 bg-brand-gold text-brand-white text-lg font-bold rounded-full hover:bg-brand-gold/90 transition-all duration-300 shadow-lg hover:shadow-brand-gold/30 hover:-translate-y-1" data-id="element-173">
            Quiero el Megapack — $19.990
          </a>
        </motion.div>
      </div>
    </section>;
}